import React from 'react';

export const OverviewSkeleton = () => {
  const skeletonCards = Array(4).fill(null);
  const skeletonRows = Array(5).fill(null);

  return (
    <div className="bg-white -mt-[calc(var(--navbar-height,64px)+3.5rem)]" style={{ minHeight: 'calc(100vh - var(--navbar-height, 64px))' }}>
      <div className="px-4 sm:px-6 lg:px-8 py-6">
        {/* Refresh bar skeleton */}
        <div className="flex items-center justify-end gap-3 mb-4 max-w-4xl mx-auto">
          <div className="h-3 w-20 bg-gray-200/50 rounded animate-shimmer-subtle"></div>
          <div className="h-3 w-14 bg-gray-200/50 rounded animate-shimmer-subtle"></div>
        </div>

        {/* Overview Stats Cards Skeleton */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mx-auto mb-6 w-full max-w-4xl">
          {skeletonCards.map((_, index) => (
            <div key={index} className="rounded-xl p-4 bg-gray-50">
              <div className="h-3 w-14 bg-gray-200/70 rounded animate-shimmer-subtle mb-1"></div>
              <div className={`h-8 bg-gray-200/70 rounded-lg animate-shimmer-subtle mb-1 ${
                index === 0 ? 'w-10' : index === 1 ? 'w-8' : index === 2 ? 'w-16' : 'w-12'
              }`}></div>
              <div className="mt-1 flex items-center gap-1">
                <div className="h-3 w-12 bg-gray-200/50 rounded animate-shimmer-subtle"></div>
                <div className="h-3 w-16 bg-gray-200/40 rounded animate-shimmer-subtle"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Response Breakdown Skeleton */}
        <div className="bg-gray-50 rounded-xl p-5 mx-auto mb-4 w-full max-w-4xl">
          <div className="h-4 w-36 bg-gray-200/70 rounded animate-shimmer-subtle mb-4"></div>
          <div className="grid grid-cols-2 gap-3">
            {[0, 1].map((i) => (
              <div key={i} className="text-center p-4 bg-white rounded-lg">
                <div className="h-8 w-10 bg-gray-200/70 rounded-lg animate-shimmer-subtle mx-auto mb-1"></div>
                <div className="h-3 w-16 bg-gray-200/50 rounded animate-shimmer-subtle mx-auto mb-1"></div>
                <div className="h-3 w-8 bg-gray-200/50 rounded animate-shimmer-subtle mx-auto"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Trend Chart Skeleton */}
        <div className="bg-gray-50 rounded-xl p-5 mx-auto mb-4 w-full max-w-4xl">
          <div className="h-4 w-28 bg-gray-200/70 rounded animate-shimmer-subtle mb-4"></div>
          <div className="bg-white rounded-lg p-4" style={{ height: 260 }}>
            <div className="w-full h-full flex items-end gap-2 px-4 pb-4">
              {[40, 55, 35, 65, 50, 70, 60].map((h, i) => (
                <div key={i} className="flex-1 flex flex-col justify-end gap-1">
                  <div className={`bg-gray-200/60 rounded-t animate-shimmer-subtle`} style={{ height: `${h}%` }}></div>
                  <div className="h-2 bg-gray-200/40 rounded animate-shimmer-subtle"></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Drop-off Section Skeleton */}
        <div className="bg-gray-50 rounded-xl p-5 mx-auto w-full max-w-4xl">
          <div className="mb-4">
            <div className="h-4 w-32 bg-gray-200/70 rounded animate-shimmer-subtle mb-1"></div>
            <div className="h-3 w-48 bg-gray-200/50 rounded animate-shimmer-subtle"></div>
          </div>

          {/* Table skeleton */}
          <div className="overflow-hidden bg-white rounded-lg">
            <table className="min-w-full">
              <thead>
                <tr className="border-b border-gray-100">
                  <th className="px-4 py-3 text-left">
                    <div className="h-3 w-16 bg-gray-200/50 rounded animate-shimmer-subtle uppercase"></div>
                  </th>
                  <th className="px-4 py-3 text-right w-24">
                    <div className="h-3 w-14 bg-gray-200/50 rounded animate-shimmer-subtle ml-auto"></div>
                  </th>
                  <th className="px-4 py-3 text-right w-24">
                    <div className="h-3 w-14 bg-gray-200/50 rounded animate-shimmer-subtle ml-auto"></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {skeletonRows.map((_, index) => (
                  <tr key={index} className="border-b border-gray-50 last:border-0">
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <div className="flex items-center justify-center gap-1 px-2 py-1 rounded bg-gray-100">
                          <div className="w-3 h-3 bg-gray-200/60 rounded animate-shimmer-subtle"></div>
                          <div className="w-3 h-3 bg-gray-200/60 rounded animate-shimmer-subtle"></div>
                        </div>
                        <div className={`h-4 bg-gray-200/60 rounded animate-shimmer-subtle ${
                          index % 3 === 0 ? 'w-48' : index % 3 === 1 ? 'w-36' : 'w-56'
                        }`}></div>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <div className="h-4 w-12 bg-gray-200/60 rounded animate-shimmer-subtle ml-auto"></div>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <div className="h-4 w-12 bg-gray-200/60 rounded animate-shimmer-subtle ml-auto"></div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
